import { configureStore } from "@reduxjs/toolkit";
import activeTileSlice from "./slices/activeTileSlice";
import tileWordSlice from "./slices/tileWordSlice";
import enteredWordSlice from "./slices/enteredWordSlice";
import targetWordSlice from "./slices/targetWordSlice";
import wordResultSlice from "./slices/wordResult";
import targetWord3Slice from "./slices/targetWord3Slice";
import word3ResultSlice from "./slices/word3Result";
import timeSlice from "./slices/timeSlice";
import categorySlice from "./slices/categoriesSlice/categorySlice";
import categoryActiveTile from "./slices/categoriesSlice/categoryActiveTile";
import categoryWord from "./slices/categoriesSlice/categoryWordSlice";
import categoryWordResult from "./slices/categoriesSlice/categoryWordResult";

const store = configureStore({
  reducer: {
    activeTileSlice: activeTileSlice.reducer,
    tileWordSlice: tileWordSlice.reducer,
    enteredWordSlice: enteredWordSlice.reducer,
    targetWordSlice: targetWordSlice.reducer,
    wordResultSlice: wordResultSlice.reducer,
    targetWord3Slice: targetWord3Slice.reducer,
    word3ResultSlice: word3ResultSlice.reducer,
    timeSlice: timeSlice.reducer,
    categorySlice: categorySlice.reducer,
    categoryActiveSlice: categoryActiveTile.reducer,
    categoryWordSlice:categoryWord.reducer,
    categoryWordResult:categoryWordResult.reducer
  },
});

export default store;
